import { ThemeProperties } from '../../core';

export interface BadgeNumberTheme {
	interactiveBackground: string;
	interactiveTextColor: string;
	brandDarkBackground: string;
	brandDarkTextColor: string;
	brandLightBackground: string;
	brandLightTextColor: string;
	neutralDarkBackground: string;
	neutralDarkTextColor: string;
	neutralLightBackground: string;
	neutralLightTextColor: string;
	smallText: string;
	mediumText: string;
}

export const theme = new ThemeProperties('badgeNumber');
